export const ObjectStatusCssClasses = ["success", "danger"];
export const ObjectStatusTitles = ["MODULES.GENERAL.STATUSENABLE", "MODULES.GENERAL.STATUSDELETED"];
export const ObjectConfirmCssClasses = ["success", "danger"];
export const ObjectConfirmTitles = ["MODULES.GENERAL.CONFIRMED", "MODULES.GENERAL.REJECTED"];
export const ObjectConditionCssClasses = ["success", "danger", ""];
export const ObjectConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "30", value: 30 },
  { text: "50", value: 50 },
];

export const ObjectAllowedCssClasses = ["danger", "success"];
export const ObjectAllowedTitles = [
  "MODULES.GENERAL.NOTALLOWED",
  "MODULES.GENERAL.ALLOWED",
];

export const ObjectAnswerTypeCssClasses = ["info", "warning", "success", "primary","danger"];
export const ObjectAnswerTypeTitles = ["MODULES.GENERAL.ANSWER1", "MODULES.GENERAL.ANSWER2", "MODULES.GENERAL.ANSWER3", "MODULES.GENERAL.ANSWER4","MODULES.GENERAL.ANSWER5"];

